import { styled } from "@mui/material"
import { NavLink } from "react-router-dom"

export const StyledNavLink = styled(NavLink)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[100]}`,
  display: "block",
  borderRadius: 4,
  padding: 15,
  "&.active": {
    background: theme.palette.primary["light"],
    borderColor: theme.palette.primary["dark"]
  }
}))
